import React from 'react'
import useTrustPilot from '../../hooks/useTrustPilot'
import { TrustPilotRatingWidget as TrustPilotRatingWidgetType } from '../../types/page'
import RatingWidget from './RatingWidget'
import useTrustPilotTopInterview from '../../hooks/useTopInterviewTrustPilot'

interface Props {
  reference: TrustPilotRatingWidgetType
}

const TrustPilotRatingWidget: React.FC<Props> = ({ reference }) => {
  const trustPilot = useTrustPilot()
  if (reference.brand === 'TopInterview') {
    return <TopInterviewRatingWidget reference={reference} />
  }

  return <RatingWidget trustPilot={trustPilot} variant={reference.variant} />
}

const TopInterviewRatingWidget: React.FC<Props> = ({ reference }) => {
  const trustPilotTI = useTrustPilotTopInterview()
  return <RatingWidget trustPilot={trustPilotTI} variant={reference.variant} />
}

export default TrustPilotRatingWidget
